import { render, staticRenderFns } from "./CandidateDashboardIntro.vue?vue&type=template&id=dd023f88&scoped=true"
import script from "./CandidateDashboardIntro.vue?vue&type=script&lang=js"
export * from "./CandidateDashboardIntro.vue?vue&type=script&lang=js"
import style0 from "./CandidateDashboardIntro.vue?vue&type=style&index=0&id=dd023f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd023f88",
  null
  
)

export default component.exports